<template>
  <div class="w-full h-full">
    <div
      v-if="isVersionsLoading"
      class="flex items-center justify-center w-full h-full"
    >
      <Loader/>
    </div>

    <FormBuilderComparison
      v-else-if="comparedFormsData.length > 0 && !isVersionsLoading"
      :comparisonData="comparedFormsData"
      class="h-full"
    />

    <div v-else class="flex items-center justify-center w-full h-full">
      <Empty />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FormBuilderComparison from "@shared/components/form-builder-comparison/index.vue";
import Loader from "@shared/loader";
import Empty from "@shared/empty";

export default {
  name: "FormBuilderComparisonContainer",

  components: {
    FormBuilderComparison,
    Loader,
    Empty,
  },

  computed: {
    ...mapGetters({
      comparedFormsData: "VersionsStore/getComparedFormsData",
      isVersionsLoading: "VersionsStore/getIsVersionsLoading",
    }),
  },
};
</script>
